import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiArrowRight, FiPhone, FiMail, FiHeart, FiShield, FiStar, FiCheckCircle, FiTruck, FiCamera, FiMusic, FiCoffee, FiPackage, FiGrid, FiDroplet, FiFlag, FiBook, FiMessageCircle, FiUser, FiSend, FiX, FiCheck, FiAlertCircle } from 'react-icons/fi';
import GigiBot from '../components/GigiBot';
import api from '../api';

const C = {
  coral: '#E3425C',
  coralDark: '#D13A4F',
  coralLight: '#F8E0E3',
  charcoal: '#1C1C1E',
  charcoalMid: '#2C2C2E',
  charcoalSoft: '#3A3A3C',
  gold: '#C9A84C',
  goldDark: '#A8872E',
  cream: '#FAFAF9',
  white: '#FFFFFF',
  gray: '#888888',
};

const KGATSO_WHATSAPP = '27617358373';

const SERVICES = [
  { key: 'funerals', label: 'Funerals', icon: <FiHeart />, desc: 'Complete funeral planning & coordination', eventType: 'Funeral' },
  { key: 'unveilings', label: 'Unveilings', icon: <FiStar />, desc: 'Memorial unveiling & tombstone ceremonies', eventType: 'Memorial / Unveiling' },
  { key: 'tombstones', label: 'Tombstones', icon: <FiShield />, desc: 'Tombstone selection, design & installation' },
  { key: 'policy', label: 'Sign Up for Policy', icon: <FiBook />, desc: 'Funeral cover & insurance plans' },
  { key: 'support', label: 'Support Services', icon: <FiPhone />, desc: 'Grief counselling & family support' },
];

const ESSENTIALS = [
  { label: 'Flowers & Coffin Spray', icon: <FiDroplet /> },
  { label: 'Family Cars & Hearse', icon: <FiTruck /> },
  { label: 'Catering', icon: <FiCoffee /> },
  { label: 'Banners & Pamphlets', icon: <FiFlag /> },
  { label: 'Branded Water Bottles', icon: <FiDroplet /> },
  { label: 'Welcome Boards', icon: <FiGrid /> },
  { label: 'Photography & Video', icon: <FiCamera /> },
  { label: 'PA System & Music', icon: <FiMusic /> },
  { label: 'Tents & Chairs', icon: <FiPackage /> },
  { label: 'Grave Decor', icon: <FiStar /> },
  { label: 'Storage', icon: <FiPackage /> },
  { label: 'And More...', icon: <FiGrid /> },
];

const HOME_ITEMS = [
  'Total Body Handling', 'Death Certificate', 'Book a grave', 'Tent', 'Buy a Casket/Coffin',
  'Coffin Spray', 'Screen & coffin trolley/stands @ home', 'Hearse & family cars or Limo',
  'Chairs at home', 'Catering tables', 'Standard toilet or Mobile toilet', 'Funeral Programmes',
  'A3 Hearse Window Photos', 'A2 Framed Photos', 'Video Camera', 'PA System', 'Grocery',
  'Deceased Clothes', 'Gas Stove and cylinder', 'Slide Show', 'Bus', 'Draping at Church or Home Tent'
];

const GRAVE_ITEMS = [
  'Gazebos', 'Grave mats & runners', 'Lowering device', 'Chairs at the grave side',
  'Chair covers & tie backs at grave side', 'Water tables with cloths',
  'Mineral water & Juice', 'Artificial flowers at grave side',
  'Tissue boxes & after mints sweets', 'Grave marker'
];

const emptyForm = () => ({
  plan: '', deceased_name: '', deceased_id: '', date_of_death: '',
  family_contact_1: '', family_contact_2: '', home_address: '',
  body_collected_from: '', time_body_collected: '', date_body_collected: '',
  delivery_date: '', delivery_time: '', burial_date: '', burial_time: '',
  cemetery: '', clothes: '', package_costs: '',
  route_home_to_church: '', route_church_to_grave: '', route_grave_to_home: '',
  checklist: {}, graveside: {}, notes: ''
});

export default function KgatsoEssentials() {
  const navigate = useNavigate();
  const [view, setView] = useState('main');
  const [activeSection, setActiveSection] = useState(null);
  const [form, setForm] = useState(emptyForm());
  const [formStep, setFormStep] = useState(1);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [savedId, setSavedId] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const updateForm = (key, val) => setForm(prev => ({ ...prev, [key]: val }));
  const updateChecklist = (item, field, val) => setForm(prev => ({ ...prev, checklist: { ...prev.checklist, [item]: { ...(prev.checklist[item] || {}), [field]: val } } }));
  const updateGraveside = (item, field, val) => setForm(prev => ({ ...prev, graveside: { ...prev.graveside, [item]: { ...(prev.graveside[item] || {}), [field]: val } } }));

  const buildWhatsAppMessage = (refId) => {
    const lines = [
      `📋 *KGATSO FUNERALS - BURIAL PREPARATION FORM*`,
      refId ? `Ref: #${refId}` : '',
      ``,
      `━━━ *DECEASED INFORMATION* ━━━`,
      `Name: ${form.deceased_name || '—'}`,
      `ID Number: ${form.deceased_id || '—'}`,
      `Date of Death: ${form.date_of_death || '—'}`,
      `Funeral Plan: ${form.plan || '—'}`,
      `Contact 1: ${form.family_contact_1 || '—'}`,
      `Contact 2: ${form.family_contact_2 || '—'}`,
      `Home Address: ${form.home_address || '—'}`,
      `Clothes: ${form.clothes || '—'}`,
      ``,
      `━━━ *COLLECTION & BURIAL* ━━━`,
      `Body Collected From: ${form.body_collected_from || '—'}`,
      `Date Collected: ${form.date_body_collected || '—'}`,
      `Time Collected: ${form.time_body_collected || '—'}`,
      `Delivery Date: ${form.delivery_date || '—'}`,
      `Delivery Time: ${form.delivery_time || '—'}`,
      `Burial Date: ${form.burial_date || '—'}`,
      `Burial Time: ${form.burial_time || '—'}`,
      `Cemetery: ${form.cemetery || '—'}`,
      `Package Cost: R${form.package_costs || '0'}`,
      ``,
      `*Routes:*`,
      `Home → Church: ${form.route_home_to_church || '—'}`,
      `Church → Grave: ${form.route_church_to_grave || '—'}`,
      `Grave → Home: ${form.route_grave_to_home || '—'}`,
    ];

    const homeSelected = HOME_ITEMS.filter(item => form.checklist[item]?.needed === 'yes');
    if (homeSelected.length > 0) {
      lines.push('', `━━━ *AT HOME ITEMS* ━━━`);
      homeSelected.forEach(item => {
        const d = form.checklist[item];
        lines.push(`✅ ${item}${d.qty ? ` (Qty: ${d.qty})` : ''}${d.cost ? ` - R${d.cost}` : ''}${d.done ? ' ✔️' : ''}`);
      });
    }

    const graveSelected = GRAVE_ITEMS.filter(item => form.graveside[item]?.needed === 'yes');
    if (graveSelected.length > 0) {
      lines.push('', `━━━ *GRAVESIDE DECOR* ━━━`);
      graveSelected.forEach(item => {
        const d = form.graveside[item];
        lines.push(`✅ ${item}${d.qty ? ` (Qty: ${d.qty})` : ''}${d.cost ? ` - R${d.cost}` : ''}${d.done ? ' ✔️' : ''}`);
      });
    }

    if (form.notes) {
      lines.push('', `━━━ *ADDITIONAL NOTES* ━━━`, form.notes);
    }

    lines.push('', `—`, `Sent via Grand Gather Registry`);
    return lines.filter(l => l !== undefined).join('\n');
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      let refId = savedId;
      if (savedId) {
        await api.put(`/kgatso/intake/${savedId}`, form);
      } else {
        const r = await api.post('/kgatso/intake', form);
        refId = r.data.id;
        setSavedId(r.data.id);
      }
      setSubmitted(true);
      const msg = buildWhatsAppMessage(refId);
      window.open(`https://wa.me/${KGATSO_WHATSAPP}?text=${encodeURIComponent(msg)}`, '_blank');
    } catch (e) {
      const msg = buildWhatsAppMessage(null);
      window.open(`https://wa.me/${KGATSO_WHATSAPP}?text=${encodeURIComponent(msg)}`, '_blank');
      setSubmitted(true);
    } finally { setSubmitting(false); }
  };

  const handleSaveDraft = async () => {
    try {
      if (savedId) {
        await api.put(`/kgatso/intake/${savedId}`, form);
      } else {
        const r = await api.post('/kgatso/intake', form);
        setSavedId(r.data.id);
      }
      alert('Draft saved! You can come back and continue later.');
    } catch { alert('Could not save. Please try again.'); }
  };

  const waLink = (msg) => `https://wa.me/${KGATSO_WHATSAPP}?text=${encodeURIComponent(msg)}`;

  const handleServiceClick = (service) => {
    if (service.eventType) {
      navigate(`/register?from=kgatso&event_type=${encodeURIComponent(service.eventType)}`);
    } else if (service.key === 'support') {
      window.open(waLink('Hi Kgatso Funerals, I need support services. Please assist.'), '_blank');
    } else {
      setActiveSection(service.key);
    }
  };

  // ── Styles matching Landing page design system ──
  const inputStyle = { width: '100%', padding: '10px 14px', borderRadius: '10px', border: '1px solid rgba(0,0,0,0.1)', background: C.white, color: C.charcoal, fontSize: '14px', fontFamily: 'DM Sans, sans-serif', outline: 'none', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', fontSize: '11px', fontWeight: 600, color: C.gray, marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.5px' };

  return (
    <div style={{ minHeight: '100vh', background: C.cream, fontFamily: "'DM Sans', sans-serif", color: C.charcoal, overflowX: 'hidden' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Serif+Display&display=swap');
        ::selection { background: #E3425C; color: white; }
        .kgatso-card { transition: all 0.3s cubic-bezier(0.16,1,0.3,1); }
        .kgatso-card:hover { transform: translateY(-4px); box-shadow: 0 12px 32px rgba(0,0,0,0.08); border-color: rgba(227,66,92,0.15) !important; }
        .ess-card { transition: all 0.25s; }
        .ess-card:hover { transform: translateY(-2px); background: rgba(227,66,92,0.04) !important; border-color: rgba(227,66,92,0.15) !important; }
        .kf-input:focus { border-color: rgba(227,66,92,0.4) !important; box-shadow: 0 0 0 3px rgba(227,66,92,0.08); }
        .kf-check-row { display: grid; grid-template-columns: 1fr 60px 60px 80px 40px; gap: 8px; align-items: center; padding: 8px 0; border-bottom: 1px solid rgba(0,0,0,0.04); font-size: 13px; }
        .kf-check-row:last-child { border-bottom: none; }
        .kf-mini-input { padding: 6px 8px; border-radius: 6px; border: 1px solid rgba(0,0,0,0.1); background: white; color: ${C.charcoal}; font-size: 12px; width: 100%; text-align: center; outline: none; font-family: inherit; }
        .kf-mini-input:focus { border-color: rgba(227,66,92,0.3); }
        .kf-done-btn { width: 28px; height: 28px; border-radius: 6px; border: 1.5px solid rgba(0,0,0,0.12); background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: center; color: rgba(0,0,0,0.2); transition: all 0.2s; }
        .kf-done-btn.checked { background: rgba(227,66,92,0.1); border-color: rgba(227,66,92,0.3); color: ${C.coral}; }
        @keyframes kgatsoGlow { 0%, 100% { box-shadow: 0 0 20px rgba(227,66,92,0.08); } 50% { box-shadow: 0 0 40px rgba(227,66,92,0.15); } }
        @keyframes kgatsoSlide { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .kgatso-marquee-wrap { position: relative; overflow: hidden; padding: 8px 0; }
        .kgatso-marquee-wrap::before { content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 140px; z-index: 2; background: linear-gradient(90deg, #FAFAF9 0%, transparent 100%); pointer-events: none; }
        .kgatso-marquee-wrap::after { content: ''; position: absolute; right: 0; top: 0; bottom: 0; width: 140px; z-index: 2; background: linear-gradient(-90deg, #FAFAF9 0%, transparent 100%); pointer-events: none; }
        .kgatso-marquee-track { display: flex; gap: 14px; animation: kgatsoSlide 35s linear infinite; width: max-content; }
        .kgatso-marquee-track:hover { animation-play-state: paused; }
        .kgatso-slide-card { position: relative; flex-shrink: 0; border-radius: 14px; overflow: hidden; border: 1px solid rgba(0,0,0,0.08); transition: all 0.4s cubic-bezier(0.16,1,0.3,1); background: white; }
        .kgatso-slide-card:hover { transform: translateY(-4px) scale(1.02); border-color: rgba(227,66,92,0.2); box-shadow: 0 12px 40px rgba(0,0,0,0.12); }
        .kgatso-slide-card img { height: 200px; width: 320px; object-fit: cover; object-position: center center; display: block; transition: transform 0.6s; image-rendering: auto; -webkit-backface-visibility: hidden; }
        .kgatso-slide-card:hover img { transform: scale(1.05); }
        .kgatso-slide-overlay { position: absolute; bottom: 0; left: 0; right: 0; padding: 28px 14px 10px; background: linear-gradient(transparent, rgba(0,0,0,0.6)); pointer-events: none; }
        .kgatso-slide-label { font-size: 11px; font-weight: 600; color: rgba(255,255,255,0.95); letter-spacing: 0.3px; }
        .kgatso-slide-tag { position: absolute; top: 10px; right: 10px; padding: 3px 10px; border-radius: 20px; background: rgba(227,66,92,0.9); backdrop-filter: blur(8px); font-size: 9px; font-weight: 700; color: white; text-transform: uppercase; letter-spacing: 0.8px; }
        @media (max-width: 768px) { .kgatso-slide-card img { height: 140px; width: 220px; } .kgatso-marquee-wrap::before, .kgatso-marquee-wrap::after { width: 60px; } }
        @media (max-width: 768px) {
          .services-grid { grid-template-columns: 1fr 1fr !important; }
          .essentials-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .kf-check-row { grid-template-columns: 1fr 50px 50px 70px 32px; font-size: 12px; }
          .hero-flex { flex-direction: column !important; text-align: center !important; align-items: center !important; }
          .form-2col { grid-template-columns: 1fr !important; }
        }
      `}</style>

      {/* ═══ NAV ═══ */}
      <nav style={{ position: 'sticky', top: 0, zIndex: 100, background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(20px) saturate(200%)', WebkitBackdropFilter: 'blur(20px) saturate(200%)', borderBottom: '1px solid rgba(0,0,0,0.06)', padding: '14px 0' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            {view === 'client-form' ? (
              <button onClick={() => { setView('main'); setFormStep(1); }} style={{ display: 'flex', alignItems: 'center', gap: '6px', background: 'none', border: 'none', color: C.charcoalSoft, cursor: 'pointer', fontSize: '14px', fontWeight: 500 }}>
                <FiArrowLeft size={16} /> Back
              </button>
            ) : (
              <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: C.charcoalSoft, fontSize: '14px', fontWeight: 500 }}>
                <FiArrowLeft size={16} /> <img src="/gift-icon-v2.png" alt="GGR" style={{ height: '28px' }} />
              </Link>
            )}
          </div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <a href={waLink('Hi Kgatso Funerals, I need assistance.')} target="_blank" rel="noopener noreferrer"
              style={{ padding: '9px 18px', borderRadius: '8px', background: '#25D366', color: 'white', textDecoration: 'none', fontSize: '12px', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '6px', transition: 'all 0.2s' }}>
              <FiMessageCircle size={14} /> WhatsApp Help
            </a>
            <Link to="/register" style={{ padding: '9px 18px', borderRadius: '8px', background: C.coral, color: 'white', textDecoration: 'none', fontSize: '12px', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '6px', boxShadow: '0 2px 12px rgba(227,66,92,0.25)', transition: 'all 0.2s' }}>
              Plan Event <FiArrowRight size={12} />
            </Link>
          </div>
        </div>
      </nav>

      {/* ═══ MAIN VIEW ═══ */}
      {view === 'main' && (
        <>
          {/* Hero — matching Landing page hero style */}
          <section style={{ padding: '60px 0 40px', background: 'linear-gradient(180deg, rgba(227,66,92,0.04) 0%, transparent 100%)' }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 28px' }}>
              <div className="hero-flex" style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
                <div style={{ width: '96px', height: '96px', borderRadius: '22px', overflow: 'hidden', flexShrink: 0, border: '2px solid rgba(227,66,92,0.15)', boxShadow: '0 8px 32px rgba(227,66,92,0.1)', animation: 'kgatsoGlow 4s ease-in-out infinite' }}>
                  <img src="/uploads/kgatso-funerals-logo.jpg" alt="Kgatso Funerals" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }} />
                </div>
                <div>
                  <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '6px 14px', borderRadius: '50px', background: 'rgba(227,66,92,0.08)', border: '1px solid rgba(227,66,92,0.12)', marginBottom: '12px' }}>
                    <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: C.coral }} />
                    <span style={{ fontSize: '10px', fontWeight: 700, color: C.coral, textTransform: 'uppercase', letterSpacing: '1.5px' }}>Essentials Powered By</span>
                  </div>
                  <h1 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 400, lineHeight: 1.12, marginBottom: '8px', color: C.charcoal, letterSpacing: '-0.01em' }}>
                    Kgatso <span style={{ color: C.coral }}>Funerals</span>
                  </h1>
                  <p style={{ fontSize: '15px', color: C.gray, lineHeight: 1.6, maxWidth: '500px' }}>
                    Comforting You In Difficulties. Plan dignified funeral services with trusted professionals and smart digital tools.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Existing Client CTA */}
          <section style={{ padding: '24px 0' }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 28px' }}>
              <div style={{
                background: C.white,
                border: '1px solid rgba(0,0,0,0.06)', borderRadius: '16px',
                padding: '24px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                flexWrap: 'wrap', gap: '16px',
                boxShadow: '0 2px 12px rgba(0,0,0,0.04)'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                  <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: 'rgba(227,66,92,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.coral }}><FiUser size={20} /></div>
                  <div>
                    <div style={{ fontSize: '15px', fontWeight: 600, marginBottom: '2px', color: C.charcoal }}>Existing Kgatso Client?</div>
                    <div style={{ fontSize: '13px', color: C.gray }}>Fill in your burial preparation form digitally — no paperwork needed</div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button onClick={() => { setView('client-form'); setFormStep(1); setForm(emptyForm()); setSubmitted(false); setSavedId(null); }}
                    style={{ padding: '11px 22px', borderRadius: '10px', background: C.coral, color: 'white', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '6px', boxShadow: '0 2px 12px rgba(227,66,92,0.2)', transition: 'all 0.2s' }}>
                    <FiBook size={14} /> Fill Burial Form
                  </button>
                  <a href={waLink('Hi Kgatso Funerals, I am an existing client and need help filling in my burial preparation form.')}
                    target="_blank" rel="noopener noreferrer"
                    style={{ padding: '11px 22px', borderRadius: '10px', background: '#25D366', color: 'white', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '6px', textDecoration: 'none', transition: 'all 0.2s' }}>
                    <FiMessageCircle size={14} /> Get Help on WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </section>

          {/* Service Showcase Slider */}
          <section style={{ padding: '36px 0', position: 'relative' }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 28px 16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                <div style={{ height: '1px', flex: 1, background: 'linear-gradient(90deg, transparent, rgba(227,66,92,0.15), transparent)' }} />
                <span style={{ fontSize: '10px', fontWeight: 700, color: C.coral, textTransform: 'uppercase', letterSpacing: '2px', whiteSpace: 'nowrap' }}>Our Services in Action</span>
                <div style={{ height: '1px', flex: 1, background: 'linear-gradient(90deg, transparent, rgba(227,66,92,0.15), transparent)' }} />
              </div>
            </div>
            <div className="kgatso-marquee-wrap">
              <div className="kgatso-marquee-track">
                {[
                  { src: '/sponsors/kgatso-fleet.jpg', label: 'Premium Fleet', tag: 'Transport' },
                  { src: '/sponsors/kgatso-setup.jpg', label: 'Tent & Chair Setup', tag: 'Decor' },
                  { src: '/sponsors/kgatso-banners.jpg', label: 'Professional Service', tag: 'On-Site' },
                  { src: '/sponsors/kgatso-logo-full.jpg', label: 'Kgatso Funerals', tag: 'Brand' },
                  { src: '/uploads/kgatso-funerals-banner.jpg', label: 'Trusted Since Day One', tag: 'Partner' },
                  { src: '/sponsors/kgatso-fleet.jpg', label: 'Premium Fleet', tag: 'Transport' },
                  { src: '/sponsors/kgatso-setup.jpg', label: 'Tent & Chair Setup', tag: 'Decor' },
                  { src: '/sponsors/kgatso-banners.jpg', label: 'Professional Service', tag: 'On-Site' },
                  { src: '/sponsors/kgatso-logo-full.jpg', label: 'Kgatso Funerals', tag: 'Brand' },
                  { src: '/uploads/kgatso-funerals-banner.jpg', label: 'Trusted Since Day One', tag: 'Partner' },
                ].map((img, i) => (
                  <div key={i} className="kgatso-slide-card">
                    <img src={img.src} alt={img.label} loading="lazy" />
                    <div className="kgatso-slide-overlay"><span className="kgatso-slide-label">{img.label}</span></div>
                    <span className="kgatso-slide-tag">{img.tag}</span>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ textAlign: 'center', marginTop: '14px' }}>
              <span style={{ fontSize: '11px', color: C.gray, fontWeight: 500, letterSpacing: '0.5px' }}>Essentials powered by <span style={{ color: C.coral, fontWeight: 700 }}>Kgatso Funerals</span></span>
            </div>
          </section>

          {/* Service Categories */}
          <section style={{ padding: '40px 0' }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 28px' }}>
              <h2 style={{ fontSize: '12px', fontWeight: 700, color: C.coral, textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '20px' }}>Services</h2>
              <div className="services-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '12px' }}>
                {SERVICES.map(s => (
                  <div key={s.key} className="kgatso-card" onClick={() => handleServiceClick(s)}
                    style={{ background: C.white, borderRadius: '16px', padding: '22px 18px', border: '1px solid rgba(0,0,0,0.06)', cursor: 'pointer', textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(227,66,92,0.08)', border: '1px solid rgba(227,66,92,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 10px', color: C.coral, fontSize: '16px' }}>{s.icon}</div>
                    <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '4px', color: C.charcoal }}>{s.label}</div>
                    <div style={{ fontSize: '11px', color: C.gray, lineHeight: 1.4 }}>{s.desc}</div>
                    {s.eventType && <div style={{ marginTop: '10px', fontSize: '11px', color: C.coral, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '3px' }}>Plan Now <FiArrowRight size={10} /></div>}
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Info panels */}
          {activeSection && (
            <section style={{ padding: '24px 0' }}>
              <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 28px' }}>
                <div style={{ background: C.white, border: '1px solid rgba(0,0,0,0.06)', borderRadius: '14px', padding: '24px 28px', position: 'relative', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
                  <button onClick={() => setActiveSection(null)} style={{ position: 'absolute', top: '12px', right: '14px', background: 'none', border: 'none', color: C.gray, cursor: 'pointer', fontSize: '18px' }}>&times;</button>
                  {activeSection === 'tombstones' && <><h3 style={{ fontSize: '16px', marginBottom: '6px', color: C.coral }}>Tombstone Services</h3><p style={{ fontSize: '13px', color: C.gray, lineHeight: 1.6 }}>Kgatso Funerals offers a range of tombstone designs. <a href={waLink('Hi, I would like to enquire about tombstone services.')} target="_blank" rel="noopener noreferrer" style={{ color: '#25D366', fontWeight: 600 }}>Chat on WhatsApp</a> for selection, custom engraving, and installation.</p></>}
                  {activeSection === 'policy' && <><h3 style={{ fontSize: '16px', marginBottom: '6px', color: C.coral }}>Funeral Cover & Policy</h3><p style={{ fontSize: '13px', color: C.gray, lineHeight: 1.6 }}>Protect your family with affordable funeral cover from R50/month. <a href={waLink('Hi, I would like to sign up for a funeral policy with Kgatso Funerals.')} target="_blank" rel="noopener noreferrer" style={{ color: '#25D366', fontWeight: 600 }}>Chat on WhatsApp</a> to discuss plans.</p></>}
                </div>
              </div>
            </section>
          )}

          {/* Essentials */}
          <section style={{ padding: '40px 0', borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 28px' }}>
              <h2 style={{ fontSize: '12px', fontWeight: 700, color: C.coral, textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '20px' }}>Funeral Service Essentials</h2>
              <div className="essentials-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
                {ESSENTIALS.map((e, i) => (
                  <div key={i} className="ess-card" style={{ background: C.white, borderRadius: '12px', padding: '16px 14px', border: '1px solid rgba(0,0,0,0.05)', boxShadow: '0 1px 3px rgba(0,0,0,0.03)' }}>
                    <div style={{ color: C.coral, fontSize: '16px', marginBottom: '8px', opacity: 0.7 }}>{e.icon}</div>
                    <div style={{ fontSize: '12px', fontWeight: 600, color: C.charcoal }}>{e.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* CTA */}
          <section style={{ padding: '60px 0', textAlign: 'center' }}>
            <div style={{ maxWidth: '500px', margin: '0 auto', padding: '0 28px' }}>
              <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 'clamp(24px, 3vw, 34px)', fontWeight: 400, marginBottom: '12px', color: C.charcoal, letterSpacing: '-0.01em' }}>
                Let us help with <span style={{ color: C.coral }}>dignity</span>
              </h2>
              <p style={{ fontSize: '14px', color: C.gray, marginBottom: '24px', lineHeight: 1.6 }}>Use Grand Gather's tools with Kgatso Funerals' expertise for a stress-free service.</p>
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <Link to="/register?from=kgatso&event_type=Funeral" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '14px 28px', background: C.coral, color: 'white', borderRadius: '10px', fontWeight: 600, fontSize: '14px', textDecoration: 'none', boxShadow: '0 4px 20px rgba(227,66,92,0.25)', transition: 'all 0.3s' }}>Plan a Funeral <FiArrowRight size={14} /></Link>
                <button onClick={() => { setView('client-form'); setFormStep(1); setForm(emptyForm()); setSubmitted(false); setSavedId(null); }}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '14px 28px', background: 'transparent', color: C.charcoal, borderRadius: '10px', fontWeight: 600, fontSize: '14px', border: '1px solid rgba(0,0,0,0.12)', cursor: 'pointer', transition: 'all 0.2s' }}>
                  <FiBook size={14} /> I'm an Existing Client
                </button>
              </div>
            </div>
          </section>
        </>
      )}

      {/* ═══ CLIENT INTAKE FORM ═══ */}
      {view === 'client-form' && !submitted && (
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '28px' }}>
          {/* Progress */}
          <div style={{ display: 'flex', gap: '4px', marginBottom: '28px' }}>
            {['Deceased Info', 'Collection & Burial', 'At Home Items', 'Graveside Decor', 'Review'].map((s, i) => (
              <div key={i} style={{ flex: 1, textAlign: 'center' }}>
                <div style={{ height: '3px', borderRadius: '2px', background: formStep > i ? C.coral : 'rgba(0,0,0,0.08)', transition: 'background 0.3s', marginBottom: '6px' }} />
                <span style={{ fontSize: '10px', color: formStep === i + 1 ? C.coral : C.gray, fontWeight: formStep === i + 1 ? 600 : 400 }}>{s}</span>
              </div>
            ))}
          </div>

          {/* WhatsApp help strip */}
          <div style={{ background: 'rgba(37,211,102,0.06)', border: '1px solid rgba(37,211,102,0.15)', borderRadius: '10px', padding: '10px 16px', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '10px', fontSize: '12px', color: C.gray }}>
            <FiAlertCircle size={14} style={{ color: '#25D366', flexShrink: 0 }} />
            <span>Need help filling this in? <a href={waLink(`Hi Kgatso Funerals, I'm filling in the burial preparation form and need assistance with Step ${formStep}.`)} target="_blank" rel="noopener noreferrer" style={{ color: '#25D366', fontWeight: 600, textDecoration: 'none' }}>Chat with Kgatso on WhatsApp</a></span>
          </div>

          {/* Step 1: Deceased Info */}
          {formStep === 1 && (
            <div style={{ background: C.white, borderRadius: '16px', border: '1px solid rgba(0,0,0,0.06)', padding: '24px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
              <h2 style={{ fontSize: '20px', fontFamily: "'DM Serif Display', serif", marginBottom: '4px', color: C.charcoal }}>Deceased <span style={{ color: C.coral }}>Information</span></h2>
              <p style={{ fontSize: '13px', color: C.gray, marginBottom: '24px' }}>Enter the details of the deceased and family contacts</p>

              <div style={{ display: 'grid', gap: '16px' }}>
                <div><label style={labelStyle}>Funeral Plan</label><input className="kf-input" style={inputStyle} value={form.plan} onChange={e => updateForm('plan', e.target.value)} placeholder="e.g., Plan A, Gold Package" /></div>
                <div className="form-2col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div><label style={labelStyle}>Deceased Full Names *</label><input className="kf-input" style={inputStyle} value={form.deceased_name} onChange={e => updateForm('deceased_name', e.target.value)} placeholder="Full names of the deceased" /></div>
                  <div><label style={labelStyle}>ID Number</label><input className="kf-input" style={inputStyle} value={form.deceased_id} onChange={e => updateForm('deceased_id', e.target.value)} placeholder="ID number" /></div>
                </div>
                <div><label style={labelStyle}>Date of Death</label><input className="kf-input" type="date" style={inputStyle} value={form.date_of_death} onChange={e => updateForm('date_of_death', e.target.value)} /></div>
                <div className="form-2col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div><label style={labelStyle}>Family Contact 1 *</label><input className="kf-input" style={inputStyle} value={form.family_contact_1} onChange={e => updateForm('family_contact_1', e.target.value)} placeholder="Phone number" /></div>
                  <div><label style={labelStyle}>Family Contact 2</label><input className="kf-input" style={inputStyle} value={form.family_contact_2} onChange={e => updateForm('family_contact_2', e.target.value)} placeholder="Phone number" /></div>
                </div>
                <div><label style={labelStyle}>Home Address</label><input className="kf-input" style={inputStyle} value={form.home_address} onChange={e => updateForm('home_address', e.target.value)} placeholder="Full home address" /></div>
                <div><label style={labelStyle}>Clothes for Deceased</label><input className="kf-input" style={inputStyle} value={form.clothes} onChange={e => updateForm('clothes', e.target.value)} placeholder="Describe clothes to dress the deceased in" /></div>
              </div>
            </div>
          )}

          {/* Step 2: Collection & Burial */}
          {formStep === 2 && (
            <div style={{ background: C.white, borderRadius: '16px', border: '1px solid rgba(0,0,0,0.06)', padding: '24px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
              <h2 style={{ fontSize: '20px', fontFamily: "'DM Serif Display', serif", marginBottom: '4px', color: C.charcoal }}>Collection & <span style={{ color: C.coral }}>Burial Details</span></h2>
              <p style={{ fontSize: '13px', color: C.gray, marginBottom: '24px' }}>Body collection, delivery, burial schedule, and routes</p>

              <div style={{ display: 'grid', gap: '16px' }}>
                <div><label style={labelStyle}>Body Collected From</label><input className="kf-input" style={inputStyle} value={form.body_collected_from} onChange={e => updateForm('body_collected_from', e.target.value)} placeholder="Hospital, mortuary, home..." /></div>
                <div className="form-2col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div><label style={labelStyle}>Date Body Collected</label><input className="kf-input" type="date" style={inputStyle} value={form.date_body_collected} onChange={e => updateForm('date_body_collected', e.target.value)} /></div>
                  <div><label style={labelStyle}>Time Body Collected</label><input className="kf-input" type="time" style={inputStyle} value={form.time_body_collected} onChange={e => updateForm('time_body_collected', e.target.value)} /></div>
                </div>
                <div className="form-2col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div><label style={labelStyle}>Delivery Date</label><input className="kf-input" type="date" style={inputStyle} value={form.delivery_date} onChange={e => updateForm('delivery_date', e.target.value)} /></div>
                  <div><label style={labelStyle}>Delivery Time</label><input className="kf-input" type="time" style={inputStyle} value={form.delivery_time} onChange={e => updateForm('delivery_time', e.target.value)} /></div>
                </div>
                <div className="form-2col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div><label style={labelStyle}>Burial Date</label><input className="kf-input" type="date" style={inputStyle} value={form.burial_date} onChange={e => updateForm('burial_date', e.target.value)} /></div>
                  <div><label style={labelStyle}>Burial Time</label><input className="kf-input" type="time" style={inputStyle} value={form.burial_time} onChange={e => updateForm('burial_time', e.target.value)} /></div>
                </div>
                <div><label style={labelStyle}>Cemetery</label><input className="kf-input" style={inputStyle} value={form.cemetery} onChange={e => updateForm('cemetery', e.target.value)} placeholder="Cemetery name and location" /></div>
                <div><label style={labelStyle}>Package Costs (R)</label><input className="kf-input" type="number" style={inputStyle} value={form.package_costs} onChange={e => updateForm('package_costs', e.target.value)} placeholder="0" /></div>

                <div style={{ borderTop: '1px solid rgba(0,0,0,0.06)', paddingTop: '16px' }}>
                  <h3 style={{ fontSize: '14px', fontWeight: 600, color: C.coral, marginBottom: '12px' }}>Routes</h3>
                  <div style={{ display: 'grid', gap: '12px' }}>
                    <div><label style={labelStyle}>Home to Church</label><input className="kf-input" style={inputStyle} value={form.route_home_to_church} onChange={e => updateForm('route_home_to_church', e.target.value)} placeholder="Route description" /></div>
                    <div><label style={labelStyle}>Church to Grave</label><input className="kf-input" style={inputStyle} value={form.route_church_to_grave} onChange={e => updateForm('route_church_to_grave', e.target.value)} placeholder="Route description" /></div>
                    <div><label style={labelStyle}>Grave to Home</label><input className="kf-input" style={inputStyle} value={form.route_grave_to_home} onChange={e => updateForm('route_grave_to_home', e.target.value)} placeholder="Route description" /></div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Step 3: At Home Checklist */}
          {formStep === 3 && (
            <div style={{ background: C.white, borderRadius: '16px', border: '1px solid rgba(0,0,0,0.06)', padding: '24px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
              <h2 style={{ fontSize: '20px', fontFamily: "'DM Serif Display', serif", marginBottom: '4px', color: C.charcoal }}>At Home <span style={{ color: C.coral }}>Checklist</span></h2>
              <p style={{ fontSize: '13px', color: C.gray, marginBottom: '16px' }}>Tick off items, enter quantities and costs. Family must prepare at least <strong style={{ color: C.coral }}>10 spade shovels!</strong></p>

              <div style={{ background: C.cream, borderRadius: '14px', border: '1px solid rgba(0,0,0,0.05)', overflow: 'hidden' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 60px 60px 80px 40px', gap: '8px', padding: '10px 14px', borderBottom: '1px solid rgba(0,0,0,0.06)', fontSize: '10px', fontWeight: 700, color: C.gray, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  <span>Item</span><span style={{ textAlign: 'center' }}>Y/N</span><span style={{ textAlign: 'center' }}>Qty</span><span style={{ textAlign: 'center' }}>Cost (R)</span><span style={{ textAlign: 'center' }}>Done</span>
                </div>
                <div style={{ padding: '4px 14px' }}>
                  {HOME_ITEMS.map(item => {
                    const d = form.checklist[item] || {};
                    return (
                      <div key={item} className="kf-check-row">
                        <span style={{ color: C.charcoalSoft }}>{item}</span>
                        <select className="kf-mini-input" value={d.needed || ''} onChange={e => updateChecklist(item, 'needed', e.target.value)}>
                          <option value="">-</option><option value="yes">Yes</option><option value="no">No</option>
                        </select>
                        <input className="kf-mini-input" type="number" value={d.qty || ''} onChange={e => updateChecklist(item, 'qty', e.target.value)} placeholder="0" />
                        <input className="kf-mini-input" type="number" value={d.cost || ''} onChange={e => updateChecklist(item, 'cost', e.target.value)} placeholder="0" />
                        <button className={`kf-done-btn ${d.done ? 'checked' : ''}`} onClick={() => updateChecklist(item, 'done', !d.done)}>
                          <FiCheck size={14} />
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}

          {/* Step 4: Graveside */}
          {formStep === 4 && (
            <div style={{ background: C.white, borderRadius: '16px', border: '1px solid rgba(0,0,0,0.06)', padding: '24px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
              <h2 style={{ fontSize: '20px', fontFamily: "'DM Serif Display', serif", marginBottom: '4px', color: C.charcoal }}>Graveside <span style={{ color: C.coral }}>Decor</span></h2>
              <p style={{ fontSize: '13px', color: C.gray, marginBottom: '16px' }}>Items needed for the graveside ceremony</p>

              <div style={{ background: C.cream, borderRadius: '14px', border: '1px solid rgba(0,0,0,0.05)', overflow: 'hidden' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 60px 60px 80px 40px', gap: '8px', padding: '10px 14px', borderBottom: '1px solid rgba(0,0,0,0.06)', fontSize: '10px', fontWeight: 700, color: C.gray, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  <span>Item</span><span style={{ textAlign: 'center' }}>Y/N</span><span style={{ textAlign: 'center' }}>Qty</span><span style={{ textAlign: 'center' }}>Amount</span><span style={{ textAlign: 'center' }}>Done</span>
                </div>
                <div style={{ padding: '4px 14px' }}>
                  {GRAVE_ITEMS.map(item => {
                    const d = form.graveside[item] || {};
                    return (
                      <div key={item} className="kf-check-row">
                        <span style={{ color: C.charcoalSoft }}>{item}</span>
                        <select className="kf-mini-input" value={d.needed || ''} onChange={e => updateGraveside(item, 'needed', e.target.value)}>
                          <option value="">-</option><option value="yes">Yes</option><option value="no">No</option>
                        </select>
                        <input className="kf-mini-input" type="number" value={d.qty || ''} onChange={e => updateGraveside(item, 'qty', e.target.value)} placeholder="0" />
                        <input className="kf-mini-input" type="number" value={d.cost || ''} onChange={e => updateGraveside(item, 'cost', e.target.value)} placeholder="0" />
                        <button className={`kf-done-btn ${d.done ? 'checked' : ''}`} onClick={() => updateGraveside(item, 'done', !d.done)}>
                          <FiCheck size={14} />
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div style={{ marginTop: '16px' }}>
                <label style={labelStyle}>Additional Notes</label>
                <textarea className="kf-input" style={{ ...inputStyle, resize: 'vertical' }} rows={3} value={form.notes} onChange={e => updateForm('notes', e.target.value)} placeholder="Any special requests, instructions, or notes for Kgatso Funerals..." />
              </div>
            </div>
          )}

          {/* Step 5: Review */}
          {formStep === 5 && (
            <div style={{ background: C.white, borderRadius: '16px', border: '1px solid rgba(0,0,0,0.06)', padding: '24px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
              <h2 style={{ fontSize: '20px', fontFamily: "'DM Serif Display', serif", marginBottom: '4px', color: C.charcoal }}>Review & <span style={{ color: C.coral }}>Submit</span></h2>
              <p style={{ fontSize: '13px', color: C.gray, marginBottom: '20px' }}>Check your details before submitting to Kgatso Funerals</p>

              <div style={{ display: 'grid', gap: '12px' }}>
                <div style={{ background: C.cream, borderRadius: '12px', border: '1px solid rgba(0,0,0,0.04)', padding: '18px' }}>
                  <h3 style={{ fontSize: '12px', fontWeight: 700, color: C.coral, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '12px' }}>Deceased Information</h3>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '13px' }}>
                    <div><span style={{ color: C.gray }}>Name:</span> <span style={{ color: C.charcoal }}>{form.deceased_name || '—'}</span></div>
                    <div><span style={{ color: C.gray }}>ID:</span> <span style={{ color: C.charcoal }}>{form.deceased_id || '—'}</span></div>
                    <div><span style={{ color: C.gray }}>Date of Death:</span> <span style={{ color: C.charcoal }}>{form.date_of_death || '—'}</span></div>
                    <div><span style={{ color: C.gray }}>Plan:</span> <span style={{ color: C.charcoal }}>{form.plan || '—'}</span></div>
                    <div><span style={{ color: C.gray }}>Contact 1:</span> <span style={{ color: C.charcoal }}>{form.family_contact_1 || '—'}</span></div>
                    <div><span style={{ color: C.gray }}>Contact 2:</span> <span style={{ color: C.charcoal }}>{form.family_contact_2 || '—'}</span></div>
                  </div>
                </div>

                <div style={{ background: C.cream, borderRadius: '12px', border: '1px solid rgba(0,0,0,0.04)', padding: '18px' }}>
                  <h3 style={{ fontSize: '12px', fontWeight: 700, color: C.coral, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '12px' }}>Burial Details</h3>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '13px' }}>
                    <div><span style={{ color: C.gray }}>Burial Date:</span> <span style={{ color: C.charcoal }}>{form.burial_date || '—'}</span></div>
                    <div><span style={{ color: C.gray }}>Burial Time:</span> <span style={{ color: C.charcoal }}>{form.burial_time || '—'}</span></div>
                    <div><span style={{ color: C.gray }}>Cemetery:</span> <span style={{ color: C.charcoal }}>{form.cemetery || '—'}</span></div>
                    <div><span style={{ color: C.gray }}>Package Cost:</span> <span style={{ color: C.charcoal }}>R{form.package_costs || '0'}</span></div>
                  </div>
                </div>

                <div style={{ background: C.cream, borderRadius: '12px', border: '1px solid rgba(0,0,0,0.04)', padding: '18px' }}>
                  <h3 style={{ fontSize: '12px', fontWeight: 700, color: C.coral, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '12px' }}>Items Selected</h3>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                    {[...HOME_ITEMS, ...GRAVE_ITEMS].filter(item => {
                      const d = form.checklist[item] || form.graveside[item] || {};
                      return d.needed === 'yes';
                    }).map(item => (
                      <span key={item} style={{ padding: '4px 10px', borderRadius: '6px', background: 'rgba(227,66,92,0.08)', fontSize: '11px', color: C.coral }}>{item}</span>
                    ))}
                    {[...HOME_ITEMS, ...GRAVE_ITEMS].filter(item => (form.checklist[item]?.needed === 'yes' || form.graveside[item]?.needed === 'yes')).length === 0 && (
                      <span style={{ fontSize: '12px', color: C.gray }}>No items selected yet</span>
                    )}
                  </div>
                </div>

                {form.notes && (
                  <div style={{ background: C.cream, borderRadius: '12px', border: '1px solid rgba(0,0,0,0.04)', padding: '18px' }}>
                    <h3 style={{ fontSize: '12px', fontWeight: 700, color: C.coral, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Notes</h3>
                    <p style={{ fontSize: '13px', color: C.gray, lineHeight: 1.6 }}>{form.notes}</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Navigation buttons */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '28px', paddingTop: '20px', borderTop: '1px solid rgba(0,0,0,0.05)' }}>
            <div>
              {formStep > 1 && (
                <button onClick={() => setFormStep(s => s - 1)} style={{ padding: '10px 20px', borderRadius: '10px', background: 'transparent', border: '1px solid rgba(0,0,0,0.12)', color: C.charcoalSoft, cursor: 'pointer', fontSize: '13px', fontWeight: 600 }}>
                  <FiArrowLeft size={13} style={{ marginRight: '6px' }} /> Previous
                </button>
              )}
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={handleSaveDraft} style={{ padding: '10px 18px', borderRadius: '10px', background: 'transparent', border: '1px solid rgba(0,0,0,0.1)', color: C.gray, cursor: 'pointer', fontSize: '12px', fontWeight: 500 }}>Save Draft</button>
              {formStep < 5 ? (
                <button onClick={() => setFormStep(s => s + 1)} disabled={formStep === 1 && !form.deceased_name}
                  style={{ padding: '10px 22px', borderRadius: '10px', background: C.coral, color: 'white', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 600, opacity: (formStep === 1 && !form.deceased_name) ? 0.4 : 1, display: 'inline-flex', alignItems: 'center', gap: '6px', boxShadow: '0 2px 12px rgba(227,66,92,0.2)' }}>
                  Next <FiArrowRight size={13} />
                </button>
              ) : (
                <button onClick={handleSubmit} disabled={submitting}
                  style={{ padding: '10px 24px', borderRadius: '10px', background: '#25D366', color: 'white', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '6px', opacity: submitting ? 0.6 : 1 }}>
                  {submitting ? 'Submitting...' : <><FiSend size={13} /> Submit to Kgatso</>}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ═══ SUCCESS STATE ═══ */}
      {view === 'client-form' && submitted && (
        <div style={{ maxWidth: '500px', margin: '0 auto', padding: '80px 28px', textAlign: 'center' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'rgba(37,211,102,0.1)', border: '2px solid rgba(37,211,102,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
            <FiCheckCircle size={28} style={{ color: '#25D366' }} />
          </div>
          <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: '26px', marginBottom: '10px', color: C.charcoal }}>Form Submitted</h2>
          <p style={{ fontSize: '14px', color: C.gray, lineHeight: 1.7, marginBottom: '28px' }}>
            Your burial preparation form has been sent to Kgatso Funerals via WhatsApp. Please press <strong style={{ color: '#25D366' }}>Send</strong> in the WhatsApp window that opened. A team member will review your details and reach out to assist you.
          </p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href={waLink(`Hi Kgatso Funerals, I just submitted my burial preparation form (Ref #${savedId}) for ${form.deceased_name}. Please assist.`)}
              target="_blank" rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '12px 22px', background: '#25D366', color: 'white', borderRadius: '10px', fontWeight: 600, fontSize: '13px', textDecoration: 'none' }}>
              <FiMessageCircle size={14} /> Follow Up on WhatsApp
            </a>
            <button onClick={() => { setView('main'); setFormStep(1); }}
              style={{ padding: '12px 22px', borderRadius: '10px', background: 'transparent', border: '1px solid rgba(0,0,0,0.12)', color: C.charcoalSoft, cursor: 'pointer', fontSize: '13px', fontWeight: 600 }}>
              Back to Kgatso
            </button>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer style={{ padding: '20px 0', borderTop: '1px solid rgba(0,0,0,0.04)', textAlign: 'center', background: C.white }}>
        <p style={{ fontSize: '11px', color: C.gray }}>
          Powered by <Link to="/" style={{ color: C.coral, textDecoration: 'none', fontWeight: 600 }}>Grand Gather Registry</Link> &middot; In partnership with Kgatso Funerals
        </p>
      </footer>

      {/* GiGi Bot */}
      <GigiBot context={{ page: 'kgatso', mode: 'kgatso' }} mode="kgatso" />
    </div>
  );
}
